module.exports = __webpack_public_path__ + "img/logo-word-first-club.c6be61e2.svg";